export const requiredFieldsByStep = {
  VEHICLE: [
    "vehicleOdometer",
    "vehicleLicensePlate",
    "vehicleId",
    "vehicleModel",
    "emissionStandard",
  ],

  DRIVER: ["driverName"],

  DEALERSHIP: [],

  CALL: [
    "vehicleOdometer",
    "vehicleLicensePlate",
    "vehicleModel",
    "driverName",
    "dealershipDn",
    "criticality",
    "vehicleStopped",
    "occurrenceType",
    "country",
    "hasLink",
    "mainOccurrence",
    "source",
    "vehiclePayloadType",
    "vehicleMaximumPayload",
    "vehicleCriticalPayload",
    "emissionStandard",
  ],
  CALL_PREVENTIVE_CHECKUP: [
    "vehicleOdometer",
    "vehicleLicensePlate",
    "vehicleModel",
    "driverName",
    "dealershipDn",
    "criticality",
    "emissionStandard",
  ],

  SCREENING: ["vehicleStopped"],
  SCREENING_PREVENTIVE_CHECKUP: [],

  DISPLACEMENT: [
    "vehicleStopped",
    "driverCheckInDriver",
    "mechanicLocation",
    "towTruckLocation",
  ],
  DISPLACEMENT_PREVENTIVE_CHECKUP: ["vehicleStopped"],

  SECOND_DIAGNOSIS: [
    "vehicleStopped",
    "hasLink",
    "mainOccurrence",
    "driverCheckInDriver",
    "mechanicLocation",
    "towTruckLocation",
  ],
  SECOND_DIAGNOSIS_PREVENTIVE_CHECKUP: [],

  REMOVAL: [
    "vehicleStopped",
    "hasLink",
    "mainOccurrence",
    "driverCheckInDriver",
    "mechanicLocation",
    "towTruckLocation",
  ],
  REMOVAL_PREVENTIVE_CHECKUP: [
    "driverCheckInDriver",
    "mechanicLocation",
    "towTruckLocation",
  ],

  THIRD_DIAGNOSIS: ["vehicleStopped"],
  THIRD_DIAGNOSIS_PREVENTIVE_CHECKUP: [],

  FOURTH_DIAGNOSIS: ["vehicleStopped", "tasNumber", "tasStatus"],
  FOURTH_DIAGNOSIS_PREVENTIVE_CHECKUP: [],

  ANALYSIS_WARRANTY: ["vehicleStopped"],
  ANALYSIS_WARRANTY_PREVENTIVE_CHECKUP: [],

  CUSTOMER_OK: ["vehicleStopped"],
  CUSTOMER_OK_PREVENTIVE_CHECKUP: [],

  PARTS: [],
  PARTS_PREVENTIVE_CHECKUP: [],

  PARTS_IN_TRANSIT: ["vehicleStopped"],
  PARTS_IN_TRANSIT_PREVENTIVE_CHECKUP: [],

  AWAITING_REPAIR: ["vehicleStopped"],
  AWAITING_REPAIR_PREVENTIVE_CHECKUP: [],

  REPAIR: ["vehicleStopped"],
  REPAIR_PREVENTIVE_CHECKUP: [],

  RELEASE: ["vehicleStopped"],
  RELEASE_PREVENTIVE_CHECKUP: [],
};
